/** Thread type */
export enum ThreadTypeEnum {
  PROJECT_COMMENTS = 'PROJECT_COMMENTS',
  BRS_TASK_COMMENTS = 'BRS_TASK_COMMENTS',
  BUDGET_REQUEST_COMMENTS = 'BUDGET_REQUEST_COMMENTS',
  DEAL_COMMENTS = 'DEAL_COMMENTS',
  DEALS_GROUP_COMMENTS = 'DEALS_GROUP_COMMENTS',
  HELPDESK_TASK_COMMENTS = 'HELPDESK_TASK_COMMENTS',
  TRANSIT_TASK_COMMENTS = 'TRANSIT_TASK_COMMENTS',
  PLANNED_INCOME_COMMENTS = 'PLANNED_INCOME_COMMENTS',
  PURCHASE_COMMENTS = 'PURCHASE_COMMENTS',
  OTHER = 'OTHER',
}
